import type { LandingPersona } from '@/hooks/useLandingPersona'

interface Props {
  persona: LandingPersona
}

const FAQS = [
  {
    q: 'What does my AI actually do?',
    a: 'It’s your AI chief of staff — a private line, for you and your approved users only. It picks up when you call your dedicated number, reads your live Facebook Ads and Stripe data out loud in plain English, and delivers a morning briefing on a schedule — phone, email, or on your dashboard. With your permission it also triages your own Gmail inbox — drafting replies for your review and clearing routine noise — and reads your calendar for the day ahead. It’s not a customer-facing receptionist. It’s the assistant you call when you want to know what’s happening in your business.',
  },
  {
    q: 'Why does Jarvis need access to my Gmail and Calendar?',
    a: 'So it can do the inbox and schedule work for you. With your explicit permission, Jarvis reads your own unread email to draft replies in your Drafts folder for you to review, flag the messages that need you, and clear routine noise (like receipts and newsletters) with a label — and it reads your calendar so your briefing knows the day ahead. It only ever touches your own account, never sends anything without your per-draft approval, and never emails your customers. Exactly what we access, use, and store is in our Privacy Policy, and you can disconnect Google any time.',
  },
  {
    q: 'Will it sound like a robot?',
    a: 'No. The five voices — JARVIS, ULTRON, ARES, SYMBIOTE, and F.R.I.D.A.Y. — each run on ElevenLabs and are fully licensed through them, so no voices are used without permission. All five are included in every plan; swap any time.',
  },
  {
    q: 'Is my data safe?',
    a: 'Yes. We follow professional industry standards across the board: per-tenant isolation in Azure, encryption at rest, restricted-scope API keys, secrets never exposed to the browser, and strict provider-side access controls on every connected service.',
  },
  {
    q: 'How long does setup take?',
    a: 'Under five minutes. Pick a plan, connect Stripe (and Facebook Ads if you want), choose a voice, and you’re live with a dedicated phone number. No integration calls, no contracts.',
  },
  {
    q: 'What happens if I go over my voice minutes?',
    a: 'Overage is billed at $0.30/min and never interrupts a call mid-conversation. You can also upgrade your tier at any time from the dashboard with one click.',
  },
  {
    q: 'Can I cancel?',
    a: 'Any time, instantly, through the Stripe customer portal. No contracts, no cancellation calls, no “retention specialist” nonsense.',
  },
]

export default function LandingFAQ({ persona }: Props) {
  return (
    <section className="lp-section" id="faq">
      <div className="lp-container">
        <div className="lp-section-header">
          <div className="lp-eyebrow">Common questions</div>
          <h2>
            Everything you’re wondering.{' '}
            <span style={{ color: persona.primary }}>Answered.</span>
          </h2>
        </div>

        <div className="lp-faq-grid">
          {FAQS.map(({ q, a }) => (
            <div key={q} className="lp-faq-item">
              <h3>{q}</h3>
              <p>{a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
